/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Grid, Box, Typography, Avatar } from '@mui/material';
import './AwardsARModal.css';
import CustomModal from '../../CustomModal/CustomModal';
import ModalHeader from '../../CustomModal/ModalHeader';
import CustomTextField from '../../../components/CustomTextField/CustomTextField';

import CompDirection from '../../../themes/CompDirection';
import { themes } from '../../../themes/themes';
import TakeActionSplitBtn from '../../../components/TakeActionSplitBtn/TakeActionSplitBtn';
import AwardHistoryARTile from '../../../components/AwardHistoryARTile/AwardHistoryARTile';
import { DateField } from '../../../../components';
import { baseDateFormatting } from '../../../helper';

interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  awardHistory: any;
  awardData: any;
  trans?: any;
  all_actions?: any;
  handleSubmitAR_Request?: any;
  userId?: any;
}

const AwardsARModalPresenter = ({
  isModalOpen,
  closeModal,
  awardData,
  all_actions,
  awardHistory,
  trans,
  handleSubmitAR_Request,
  userId,
}: ModalProps) => {
  const handleTakeAction = (x: any) => {
    if (x) {
      const payload = {
        instanceId: awardData?.id,
        userId: userId,
        action: x ? x : '',
        event: 'award',
        context: {},
        model: 'emp_awards',
      };
      handleSubmitAR_Request(payload);
    } else {
      return;
    }
  };

  return (
    <CustomModal isModalOpen={isModalOpen} modalHeight="98vh" modalWidth="35vw">
      <ModalHeader
        modal={{ modal_title: trans('Promotions Action Required') }}
        closeModal={closeModal}
      />
      <CompDirection>
        <Grid
          container
          spacing={2}
          style={{
            marginTop: '5px',
          }}
        >
          <Grid item xs={6}>
            <Box className="bg_border_ar_promotion">
              <Box
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Avatar />
                <Box style={{ paddingLeft: '10px' }}>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      color: themes.darkBlue,
                      fontSize: '1em',
                      fontWeight: 'bold',
                    }}
                  >
                    {awardData?.first_name + ' ' + awardData?.last_name}
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      color: themes.grey_colorDesignationAR,
                      fontSize: '0.825em',
                    }}
                  >
                    {awardData?.department_name} / {awardData?.designation_name}
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{
                  display: 'flex',
                  padding: '1em',
                  marginTop: '0.5em',
                  width: 'auto',
                  backgroundColor: '#F5F5FA66',
                  height: '30px',
                  flexDirection: 'column',
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      color: themes.greyModalTitle,
                    }}
                  >
                    Date
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      color: themes.defaultScondary_blue,
                    }}
                  >
                    <DateField
                      value={awardData.award_date}
                      format={baseDateFormatting}
                    />
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{
                  display: 'flex',
                  padding: '1em',
                  marginTop: '0.5em',
                  width: 'auto',
                  backgroundColor: '#F5F5FA66',
                  height: '30px',
                  flexDirection: 'column',
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      color: themes.greyModalTitle,
                    }}
                  >
                    Award Type
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      color: themes.defaultScondary_blue,
                    }}
                  >
                    {awardData.award}
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{
                  display: 'flex',
                  padding: '1em',
                  marginTop: '0.5em',
                  width: 'auto',
                  backgroundColor: '#F5F5FA66',
                  height: '30px',
                  flexDirection: 'column',
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      color: themes.greyModalTitle,
                    }}
                  >
                    Gift Type
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      color: themes.primaryMain,
                      backgroundColor: '#F2E6F0',
                      padding: '5px',
                      borderRadius: '4px',
                    }}
                  >
                    {awardData?.gift ? awardData?.gift : '--'}
                  </Typography>
                </Box>
              </Box>

              <Box
                style={{
                  display: 'flex',
                  padding: '1em',
                  marginTop: '0.5em',
                  width: 'auto',
                  backgroundColor: '#F5F5FA66',
                  height: '30px',
                  flexDirection: 'column',
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      color: themes.greyModalTitle,
                    }}
                  >
                    Message
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      color: themes.defaultScondary_blue,
                    }}
                  >
                    {awardData?.message ? awardData?.message : '--'}
                  </Typography>
                </Box>
              </Box>
              {/* <Box
                style={{
                  display: "flex",
                  marginTop: "0.5em",
                  width: "auto",
                  height: "30px",
                  flexDirection: "column",
                }}
              >
                <Typography
                  style={{
                    fontFamily: "Lato",
                    fontSize: "14px",
                    fontWeight: "bold",
                    color: themes.defaultScondary_blue,
                  }}
                >
                  Remarks
                </Typography>
                <Typography
                  style={{
                    fontFamily: "Lato",
                    fontSize: "12px",
                    color: themes.greyModalTitle,
                  }}
                >
                  Last 4 days I am not good
                </Typography>
              </Box> */}
              <Box style={{ marginTop: '1.5em' }}>
                <CustomTextField
                  type="string"
                  label="Comment"
                  placeholder="Write Comment"
                />
              </Box>
              <Box style={{ marginTop: '1.5em', zIndex: '999', width: '100%' }}>
                <TakeActionSplitBtn
                  menu={all_actions}
                  title={'Take Action'}
                  onAction={(x: any) => handleTakeAction(x)}
                />
              </Box>
            </Box>
          </Grid>
          {/* {Second Column} */}

          <Grid item xs={6}>
            <Box className="bg_border_ar_promotion">
              <Box
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Typography
                  style={{
                    fontFamily: 'Lato',
                    color: themes.primaryMain,
                    fontSize: '0.875em',
                    fontWeight: 'bold',
                  }}
                >
                  Award History
                </Typography>
              </Box>
              <Box
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <Typography
                  style={{
                    fontFamily: 'Lato',
                    color: themes.greySubtitle,
                    fontSize: '0.875em',
                    fontWeight: 'bold',
                  }}
                >
                  Type:{' '}
                  <span style={{ color: themes.defaultScondary_blue }}>
                    All
                  </span>
                </Typography>
                <Box
                  style={{
                    border: '1px solid #979797',
                    borderRadius: '4px',
                    alignSelf: 'center',
                    padding: '8px',
                    cursor: 'pointer',
                  }}
                >
                  <i className="las la-filter" color="#464545" />
                </Box>
              </Box>
              {awardHistory?.length > 0 &&
                awardHistory.map((data: any) => {
                  return (
                    <div key={data?.id}>
                      <AwardHistoryARTile
                        name={data?.award_type?.name}
                        gift={data?.gift ? data?.gift : '--'}
                        designation={`${awardData?.department_name} / ${awardData?.designation_name}`}
                        message={data?.description}
                      />
                    </div>
                  );
                })}
            </Box>
          </Grid>

          {/* {Horizontals Steps Label} */}
          {/* <Grid item xs={12}>
            <Box
              style={{
                border: "1px solid #0000001f",
                padding: "10px",
                borderRadius: "10px",
              }}
            >
              <HorizontalStepperForActionRequired direction="horizontal" />
            </Box>
          </Grid> */}
        </Grid>
      </CompDirection>
    </CustomModal>
  );
};

export default AwardsARModalPresenter;
